jQuery(document).ready(function($) {

    //mobile main menu collapse
    $('#menu-collapse').click(function(){
        $('.menu-mobile').toggleClass('open');
    });

    //mobile search form collapse
    $('#toggle-search').click(function(){
        $('.search-form-mobile').toggleClass('open');
    });

    //mobile current page mobile menu collapse
    $('div.dropdown-title').click(function(){
        $(this).next().toggleClass('open');
    });

    // Fancybox Popup
    $('.fancybox-media').fancybox({
        openEffect  : 'fade',
        closeEffect : 'fade',
        nextEffect : 'fade',
        prevEffect : 'fade',
        helpers     : {
            title   : { type : 'inside' }
        }
    });

    //ajax loading more interviews
    if($('#videos-list .ajax').length > 0){
        var paged = 2;
        var isPreviousEventComplete = true;
        var isDataAvailable = true;
        var icon_more = $('#videos-list .more');

        icon_more.click(function () {
            if (isPreviousEventComplete && isDataAvailable) {
                isPreviousEventComplete = false;
                icon_more.addClass('loading');
                $.ajax({
                    type : 'POST',
                    url : ajaxurl,
                    data : { action: 'get_more_videos', paged : paged, post_type : video_post_type },
                    success: function(result) {
                        $('#videos-list .ajax').append(result);
                        paged++;
                        isPreviousEventComplete = true;
                        if (result.trim() == '') {
                            isDataAvailable = false;
                            icon_more.remove();
                        } else{
                            icon_more.removeClass('loading');
                        }
                    }
                });
            }
        });
    }

    // wrap iframe
    //$('.des iframe, .video-block iframe, .des embed').not('des.no-iframe').wrap('<div class="iframe-wrapper"></div>');
    $('.des iframe, .video-block iframe, .des embed').not('des.no-iframe').each(function(){
        if(($(this).attr('src').search('soundcloud.com')) === -1){
            $(this).wrap('<div class="iframe-wrapper"></div>');
        }
    });


    // Slick slider init
    $('.slick-slider-block').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });

    // Slick slider init Center page
    $('.slick-slider-block-center').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slick-slider-block-center-nav',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: true
                }
            }
        ]

    });

    $('.slick-slider-block-center-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slick-slider-block-center',
        dots: true,
        centerMode: false,
        focusOnSelect: true
    });


    // Row min height
    if($('#home-related-interviews').length > 0){
        var height_title = 0;
        $('#home-related-interviews h3 a').each(function(){
            var thiss = $(this);
            if(thiss.height() > height_title){
                height_title = thiss.height();
            }
        });
        $('#home-related-interviews h3 a').css('min-height',height_title+'px');
    }

});
